module.exports = __webpack_public_path__ + "static/img/sdgs.95da3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/sdgs.png
// module id = Zks9
// module chunks = 0